import TableComponentV2, { Header, KeyHeader } from '../../../shared/TableComponentV2';
import Icon from '@mdi/react';
import { mdiFileExcel, mdiListBox } from '@mdi/js';
import { Popover, PopoverContent, PopoverTrigger } from '../../../ui/popover';
import { Button } from '../../../ui/button';
import * as XLSX from 'xlsx';

export interface IPropsTableMessageComponent {
    data: {
        meta: {
            columns: {
                key: string;
                name: string;
                sortable: boolean;
            }[];
            defaultSort: {
                column: string;
                order: string;
            };
            data: {
                [key: string]: any;
            }[];
        };
    };
}

export default function TableMessageComponent(props: IPropsTableMessageComponent) {
    const { data } = props;

    function exportFileXlsx() {
        const worksheet = XLSX.utils.json_to_sheet(data.meta.data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'message_response');
        XLSX.writeFile(workbook, new Date().toFormattedDate('yyyy-MM-dd HH:mm a') + '.xlsx');
    }

    function exportFileCsv() {
        const worksheet = XLSX.utils.json_to_sheet(data.meta.data);
        const csv = XLSX.utils.sheet_to_csv(worksheet);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = new Date().toFormattedDate('yyyy-MM-dd HH:mm a') + '.csv';
        a.click();
        URL.revokeObjectURL(url);
    }

    return (
        <div className="pt-3">
            <TableComponentV2
                topActions={
                    <div>
                        <Popover>
                            <PopoverTrigger>
                                <Button className="relative" variant="link">
                                    Actions: <Icon path={mdiListBox} size={1} />
                                </Button>
                            </PopoverTrigger>
                            <PopoverContent className="bg-white w-[180px] text-xs mr-[42px]">
                                <div className="p-2 flex flex-col gap-2 items-start">
                                    <Button variant="link" onClick={() => exportFileCsv()}>
                                        <Icon path={mdiFileExcel} size={1} /> Export to CSV
                                    </Button>
                                    <Button variant="link" onClick={() => exportFileXlsx()}>
                                        <Icon path={mdiFileExcel} size={1} /> Export to XLSX
                                    </Button>
                                </div>
                            </PopoverContent>
                        </Popover>
                    </div>
                }
                classNameContainer="w-full"
                items={data?.meta.data ?? []}
                defaultSort={
                    data.meta.defaultSort
                        ? {
                              key: data.meta.defaultSort.column,
                              order: data.meta.defaultSort.order as 'asc' | 'desc',
                          }
                        : undefined
                }
                header={
                    data?.meta?.columns
                        ? data.meta.columns.map((h) => {
                              return {
                                  label: h.name,
                                  visible: true,
                                  sortable: h.sortable,
                                  absoluteKey: h.key,
                                  className:
                                      'px-4 py-3 text-left text-xs font-semibold text-purple-700 uppercase tracking-wider',
                                  type: KeyHeader.KEY,
                                  key: h.key,
                              } as Header<any>;
                          })
                        : []
                }
                pagination
                search
            />
        </div>
    );
}
